import { PropertyType } from '@gql';

export const mapPropertyTypeToTitle = (propertyType: PropertyType): string => {
  switch (propertyType) {
    case PropertyType.Apartment:
      return 'Apartment';
    case PropertyType.BedAndBreakfast:
      return 'Bed and Breakfast';
    case PropertyType.BoutiqueHotel:
      return 'Boutique Hotel';
    case PropertyType.House:
      return 'House';
    case PropertyType.GuestHouse:
      return 'Guest House';
    default:
      return propertyType;
  }
};
